export default {"src":"/_next/static/media/redpotato.0f705d6a.svg","height":681,"width":681,"blurWidth":0,"blurHeight":0};